import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from '../../hooks/useMsal';
import { LoadingSpinner } from '../common/LoadingSpinner';
import { ROUTES } from '../../utils/constants';

interface AuthGuardProps {
  children: ReactNode;
  roles?: string[];
}

/**
 * Protected route wrapper component
 * Checks if user is authenticated before rendering children
 * Optionally checks for required roles
 */
export const AuthGuard = ({ children, roles }: AuthGuardProps) => {
  const isAuthenticated = useIsAuthenticated();
  const { isLoading, hasAnyRole } = useMsal();
  const location = useLocation();

  // Show loading spinner while authentication is in progress
  if (isLoading) {
    return <LoadingSpinner fullScreen message="Ověřování..." />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  // Check roles if specified
  if (roles && roles.length > 0) {
    if (!hasAnyRole(roles)) {
      return <Navigate to={ROUTES.DASHBOARD} replace />;
    }
  }

  return <>{children}</>;
};
